import { styled } from 'linaria/react';

export const StyledSection = styled.section`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: var(--text-primary);

	ol {
		padding-left: 44px;
		counter-reset: item;

		& > li {
			position: relative;
			display: block;
			margin-top: 16px;

			&::before {
				position: absolute;
				top: 0;
				left: -44px;
				font-weight: 500;
				font-size: 16px;
				line-height: 24px;
				counter-increment: item;
				content: counters(item, '.') '. ';
			}

			& > ol {
				padding: 0;

				& > li::before {
					font-weight: 400;
					font-size: 14px;
					line-height: 20px;
				}
			}
		}
	}

	div > ol > li:first-child {
		margin: 0;
	}

	li.bold::before {
		font-weight: bold;
	}

	ul {
		padding: 0 0 0 12px;
		margin: 0;

		& > li {
			display: list-item;
			margin-top: 8px;
			list-style: outside disc;

			&::marker {
				font-size: 10px;
			}
		}
	}

	h2 {
		font-weight: 500;
		font-size: 20px;
		line-height: 26px;
	}

	h3 {
		display: inline;
		font-weight: 500;
		font-size: 16px;
		line-height: 24px;
	}

	a {
		text-decoration: none;
		color: var(--brand-dark);
		cursor: pointer;
	}

	p {
		margin: 8px 0 0;
	}
`;
